import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export const StyledTabsNavigation = styled.nav`
  width: 100%;
  border-bottom: 1px solid var(--line);
`;

export const StyledTabsNavigationList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: inline-flex;
  align-items: center;
`;

export const StyledTabsNavigationListItem = styled.li`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  flex-grow: 1;
  &:not(:first-child) {
    margin-left: 1.75rem;
  }
`;

export const StyledTabsNavigationLink = styled(NavLink).attrs({
  activeClassName: 'is-active',
})`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  text-decoration: none;
  transition: color var(--dur-base) var(--ease-out),
    border-color var(--dur-base) var(--ease-out);
  color: var(--muted);
  font-weight: var(--weight-medium);
  font-size: var(--t-base);
  letter-spacing: -0.005em;
  border-width: 0 0 2px;
  border-style: solid;
  border-color: transparent;
  padding: 0.625rem 0 0.5rem;
  margin-bottom: -1px;
  &.is-active {
    color: var(--ink);
    font-weight: var(--weight-semibold);
    border-bottom-color: var(--brand-green);
  }
  &:hover:not(.is-active) {
    color: var(--ink);
    border-bottom-color: rgba(118, 177, 89, 0.4);
  }
`;
